import { Controller } from 'react-hook-form';

import { Select } from '../Select/index.js';
import type { FormSelectProps } from './FormSelect.types.js';

export const FormSelect = ({
  field,
  control,
  transform,
  errorExists,
  errorText,
  clearable,
}: FormSelectProps) => {
  return (
    <Controller
      key={`${field.name}`}
      name={field.name}
      control={control}
      render={({ field: { value, onChange, onBlur }, fieldState: { error } }) => {
        return (
          <Select
            field={field}
            errorExists={errorExists ?? Boolean(error)}
            errorText={errorText ?? error?.message ?? ''}
            disabled={field?.disabled}
            onBlur={onBlur}
            onClear={clearable ? () => onChange({ target: { value: undefined } }) : undefined}
            onChange={(e) => {
              const value = transform ? transform.onChange(e) : e;
              onChange(value);
              field.onAfterChangeHook?.(value);
            }}
            data-testid="select-account-role"
            value={transform ? transform.value(value) : value}
          />
        );
      }}
    />
  );
};
